var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.timeline = !vm.sideTab.timeline\">Close</md-button></div><div layout=\"column\"><h3>Add New Event</h3><div flex=\"25\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Start Time</label><time-picker field=\"vm.models.newEventStep.time\"></time-picker></div><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">End Time</label><time-picker field=\"vm.models.newEventStep.endTime\"></time-picker></div><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Description</label><input ng-model=\"vm.models.newEventStep.description\" class=\"form-control\"/></div><div class=\"form-group\"><div ng-click=\"vm.addEventStep()\" class=\"btn btn-primary\">Add Item</div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/addTimeline.jade
// module id = 280
// module chunks = 0